/*-----------------------------------------------------------------
- Contact translations
-----------------------------------------------------------------*/
export default {

    title        : 'تماس با ما',
    contact_title: 'راه‌های ارتباطی با ما',
    map          : '{0} را روی نقشه پیدا کنید',

};
